<template>
  <el-dropdown :popup-max-height="false" @command="handleLogin">
    <el-button type="primary" size="small">
      免密登录
      <el-icon class="el-icon--right">
        <ArrowDown />
      </el-icon>
    </el-button>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item v-for="(item,index) in products" :key="index" :command="item.value">{{ item.label }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script>
import { postSafeLogin } from "@/api/user";
import { useUserStore } from "@/store";
import { ArrowDown } from "@element-plus/icons-vue";


export default {
  components: { ArrowDown },
  props: {
    id: String
  },
  data() {
    return {
      products: [
        { value: "ads", label: "抖音竞价" },
        { value: "bjh", label: "百家号" },
        { value: "xhs", label: "小红书" },
        { value: "tuwen", label: "抖音图文" }
      ]
    };
  },
  created() {
    this.products.forEach(item => {
      if (useUserStore().profilesUserInfo.products.every(j => j.key != item.value)) {
        this.products = this.products.filter(n => n.value != item.value);
      }
    });
  },
  methods: {
    handleLogin(val) {
      postSafeLogin({ user_id: this.id, product_key: val }).then((res) => {
        const a = document.createElement("a");
        if (res.data.url) {
          a.href = `http://${res.data.url}?token=${res.data.token}`;
        } else {
          a.href = `${window.location.origin}?token=${res.data.token}`;
        }
        a.target = "_blank";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }).catch(() => {
        // 业务错误已由拦截器 ElMessage 提示
      });
    }
  }
};
</script>

<style>

</style>
